import axios from "axios";

const authService = axios.create({
  baseURL:
    "https://apierp-seguranca.invitatech.com.br:2001/api/segurancas/tokens",
});

export default authService;
